import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAO1PQ2CNtqdcxz0psaUqPeoOqHP5PrESI",
  authDomain: "maison-chateaux-d-eau.firebaseapp.com",
  projectId: "maison-chateaux-d-eau"
};

export const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
